<template>
  <div class="w-full flex flex-col mt-4">
    <div class="flex flex-row text-center pt-8 relative">
      <p
        v-if="currentStep.error"
        class="text-red-500 text-xs italic absolute top-2"
      >
        {{ currentStep.error }}
      </p>

      <v-otp-input
        ref="otpInput"
        :input-classes="defaultInpClasses"
        separator=" "
        :num-inputs="inpNumber"
        :should-auto-focus="true"
        :is-input-num="true"
        @on-change="handleOnChange"
        @on-complete="handleOnComplete"
      />
    </div>

    <div class="mt-2">
      <p
        class="text-sm font-sans text-gray-400 italic my-3 text-center"
        v-if="!!countTime"
      >
        OTP expires in {{ countTime }} seconds
      </p>
      <p class="text-sm font-sans text-gray-400 text-center">
        Didn't receive code?
        <span
          class="font-semibold text-gray-600 cursor-pointer duration-150 hover:text-blue-300"
          @click.prevent="reqGenNewOTP"
        >
          Request again
        </span>
      </p>
    </div>
  </div>
</template>

<script>
import { service_names } from "@/constants/Services";
// import { NotificationStore } from "@/components/NotificationPlugin";

export default {
  name: "App",
  props: ["currentStep"],
  data() {
    return {
      defaultInpClasses:
        "otp-input w-[30px] h-[30px] my-0 mx-2 border border-gray-300 rounded-[4px] font-sans font-medium text-gray-800 text-center",
      countTime: 60,
      countTimeClock: null,
      inpNumber: 6
    };
  },
  methods: {
    handleOnComplete(value) {
      this.$set(this.currentStep, "otpCode", value);
      this.$emit("can-continue", { value: true });
    },
    handleOnChange(value) {
      const valStr = value + "";
      const isCanFinish = valStr.length === this.inpNumber;

      this.$emit("can-continue", { value: isCanFinish });
    },
    reqGenNewOTP() {
      const path = `${service_names.utility}/otp/generate`;
      this.$axios.post(path).then(() => {
        this.currentStep.error && this.$set(this.currentStep, "error", "");
        this.initNewCountTimeClock();
      });
    },

    initNewCountTimeClock() {
      if (this.countTimeClock) clearInterval(this.countTimeClock);

      this.countTimeClock = setInterval(() => {
        if (this.countTime === 0) {
          clearInterval(this.countTimeClock);
          return;
        }

        this.countTime -= 1;
      }, 1000);
    }
  },
  mounted() {
    this.reqGenNewOTP();
  },
  destroyed() {
    this.countTimeClock && clearInterval(this.countTimeClock);
  }
};
</script>

<style lang="scss">
.otp-input {
  caret-color: #5995fd;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  &.error {
    border: 1px solid #ef4444 !important;
  }
}
.otp-input::-webkit-inner-spin-button,
.otp-input::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
